import { DomSanitizer } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
    constructor(private readonly sanitized: DomSanitizer) { }
    public transform(value): any {
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
}
